<template>
    <div>
        <card-header title="Trip Wall" icon="fa-images"/>
        <card-toolbar>
            <button @click="$openCard('new-wall-post', {tripId: props.tripId}, card)">
                <i class="fas fa-plus mr-2"/>New Post
            </button>
            <button :class="{'is-active': hiddenOnly}" @click="hiddenOnly = !hiddenOnly">
                <i class="fas fa-eye-slash mr-2"/>{{ hiddenOnly ? 'Showing hidden only' : 'Show hidden only' }}
            </button>
        </card-toolbar>

        <card-body>
            <card-list>
                <wall-post-list-item
                    v-for="post in filteredPosts"
                    :key="post.id"
                    :card="card"
                    :post="post"
                    :active="(child && child.definition.component === 'wall-post') && child.props && Number(child.props.postId) === post.id"
                    @click="$openCard('wall-post', {tripId: props.tripId, postId: post.id}, card)"
                    @hide="toggleHide(post)"
                    @delete="deletePost(post)"
                />

                <container-list-item padded v-if="!filteredPosts.length && !loading">
                    <p class="has-text-grey is-italic">{{ hiddenOnly ? 'No hidden posts — nothing needs review.' : 'Nothing on the wall yet.' }}</p>
                </container-list-item>
            </card-list>

            <div class="has-text-centered mt-3 mb-3" v-if="!done && posts.length">
                <b-button size="is-small" @click="loadMore">Load earlier posts</b-button>
            </div>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardList from "@/TIER/components/CardList";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import WallPostListItem from "@/components/WallPostListItem";

    import {client as http} from '@/http_client';

    export default {
        name: "TripWall",
        props: ['card', 'child', 'props'],
        components: {WallPostListItem, ContainerListItem, CardList, CardToolbar, CardBody, CardHeader},
        data: function() {
            return {
                posts: [],
                hiddenOnly: false,
                done: false,
                loading: true
            };
        },
        computed: {
            filteredPosts: function() {
                return this.hiddenOnly ? this.posts.filter(p => p.hidden) : this.posts;
            }
        },
        methods: {
            load: function(force) {
                this.$emit('loading', true);
                http.get('/api/experience/trips/' + this.props.tripId + '/wall?limit=50', {force}).then(response => {
                    this.posts = response.data.posts;
                    this.done = response.data.posts.length < response.data.limit;
                    this.loading = false;
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.load(true);
            },
            loadMore: function() {
                const oldest = this.posts.length ? this.posts[this.posts.length - 1].id : null;
                if (!oldest) return;
                http.get('/api/experience/trips/' + this.props.tripId + '/wall?limit=50&before=' + oldest, {force: true}).then(response => {
                    this.posts = this.posts.concat(response.data.posts);
                    this.done = response.data.posts.length < response.data.limit;
                });
            },
            toggleHide: function(post) {
                http.put('/api/experience/posts/' + post.id + '/hide', {hidden: post.hidden ? 0 : 1}, {force: true}).then(() => {
                    post.hidden = post.hidden ? 0 : 1;
                });
            },
            deletePost: function(post) {
                this.$buefy.dialog.confirm({
                    title: 'Delete Post',
                    message: 'Delete this wall post for everyone? This can\'t be undone.',
                    confirmText: 'Delete',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        http.delete('/api/experience/posts/' + post.id, {force: true}).then(() => {
                            this.posts = this.posts.filter(p => p.id !== post.id);
                        });
                    }
                });
            },
        },
        mounted() {
            this.load(true);
        }
    };
</script>

<style lang="scss" scoped>
</style>
